





















































/* eslint-disable */
import { createComponent, ref, Ref, computed } from "@vue/composition-api";
import { Menu, MenuItemType } from "@web-components/types/Menu";
/* eslint-enable */

interface BaseMenuProps {
  menu: Menu;
  selectedTitle?: String;
}

export default createComponent({
  props: {
    menu: {
      type: Object as () => Menu,
      required: true
    },
    selectedTitle: {
      type: String,
      required: false
    }
  },
  setup(props: Readonly<BaseMenuProps>, context) {
    const currentMenu: Ref<Menu | MenuItemType> = ref(props.menu);
    const breadcrumbs: Ref<Menu[]> = ref([]);

    const displayTitle = computed(() => {
      if (typeof currentMenu.value == "object" && currentMenu.value.title) {
        return currentMenu.value.title;
      } else {
        return props.selectedTitle || "";
      }
    });

    const allSelectedOptions: Ref<string[]> = ref([]);

    const handleClick = (name: string) => {
      allSelectedOptions.value.push(name);
      const menu = currentMenu.value as Menu;

      if (!menu.items || !menu.items[name]) return;
      breadcrumbs.value.push(menu);

      const nextMenuItem = menu.items[name].value;

      if (typeof nextMenuItem == "object") {
        currentMenu.value = nextMenuItem as Menu;
      } else {
        if (
          typeof nextMenuItem == "string" ||
          typeof nextMenuItem == "number"
        ) {
          currentMenu.value = nextMenuItem;

          context.emit("selected", {
            value: name,
            allSelectedOptions: allSelectedOptions.value
          });
        }
      }
    };

    const resetMenu = () => {
      currentMenu.value = props.menu;
      breadcrumbs.value = [];
      allSelectedOptions.value = [];
    };

    const handleGoBack = () => {
      const prevMenu = breadcrumbs.value.pop();
      allSelectedOptions.value.pop();
      if (prevMenu) {
        currentMenu.value = prevMenu;
      }
    };

    return {
      currentMenu,
      breadcrumbs,
      handleClick,
      handleGoBack,
      resetMenu,
      displayTitle
    };
  }
});
